import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";
import {licenseModules} from "@/composables/useLicense";

export default {
    /*
    |--------------------------------------------------------------------------
    | Shop Routes
    |--------------------------------------------------------------------------|
    */

    path: 'shop',
    name: 'shop',
    children: [
        {
            path: 'statistics',
            name: 'shop-statistic',
            component: () => import('@/Modules/Shop/views/stats/Statistic.vue'),
            meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.STATISTIC_MINI]}
        },
        {
            path: 'statistics-sales',
            name: 'shop-statistic-sales',
            component: () => import('@/Modules/Shop/views/stats/sales/index.vue'),
            meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.STATISTIC_LITE] ,requiresLicense: licenseModules.STAT_SALES_WEB }
        },
        {
            path: 'statistics-categories',
            name: 'shop-statistic-categories',
            component: () => import('@/Modules/Shop/views/stats/category/index.vue'),
            meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.STATISTIC_LITE],requiresLicense: licenseModules.STAT_CATEGORIES_WEB  }
        },
        {
            path: 'statistics-customer',
            name: 'shop-statistic-customer',
            component: () => import('@/Modules/Shop/views/stats/customer/index.vue'),
            meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.STATISTIC_LITE],requiresLicense: licenseModules.STAT_CUSTOMERS_WEB  }
        },
        {
            path: '',
            name: 'shop-index',
            component: () => import('@/Modules/Shop/views/shop/Index.vue'),
            meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }
        },
        {
            path: ':id',
            name: 'shop-view',
            component: () => import('@/Modules/Shop/views/shop/View.vue'),
            meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] },
            children: [
                {
                    path: 'products',
                    name: 'shop-products',
                    component: () => import('@/Modules/Shop/views/products/Index.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }
                },
                {
                    path: 'storage',
                    name : 'entering-storage',
                    component : () => import('@/Modules/Shop/views/storage/Index.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }

                },
                {
                    path: 'stock-transfer',
                    name : 'stock-transfer',
                    component : () => import('@/Modules/Shop/views/transfer/Index.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] },

                },
                {
                    path: 'supplies',
                    component: () => import('@/Modules/Shop/views/shop/Supplie.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] },
                    children: [
                        {
                            path: '',
                            name: 'shop-supplies',
                            component: () => import('@/Modules/Shop/views/shop/SupplieList.vue'),
                            meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }
                        },
                        {
                            path: ':supplyId/detail',
                            name: 'shop-supply-detail',
                            component: () => import('@/Modules/Shop/views/shop/SupplieDetail.vue'),
                            meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }
                        },
                    ]
                },
                {
                    path: 'agents',
                    name : 'agents',
                    component : () => import('@/Modules/Shop/views/agents/Index.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }

                },
                {
                    path: 'box',
                    name : 'box',
                    component : () => import('@/Modules/Shop/views/box/Index.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }

                },
                {
                    path: 'sales',
                    name : 'sales',
                    component : () => import('@/Modules/Shop/views/sales/Index.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }

                },
                {
                    path: 'entrepot-config',
                    name : 'entrepot-config',
                    component : () => import('@/Modules/Shop/views/config/Index.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.STORE] }
                },
                {
                    path: 'users',
                    name: 'shop-users',
                    component: () => import('@/Modules/Shop/views/shop/ShopUsers.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }
                },
                {
                    path: 'boxes',
                    name: 'shop-boxes',
                    component: () => import('@/Modules/Shop/views/shop/ShopBoxes.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }
                },
                {
                    path: 'shop-sales',
                    name: 'shop-sales',
                    component: () => import('@/Modules/Shop/views/shop/ShopSales.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }
                },
                {
                    path: 'store/config',
                    name: 'shop-store-config',
                    component: () => import('@/Modules/Shop/views/shop/ShopStoreConfig.vue'),
                    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.STORE] }
                },
                {
                    path: 'bundles',
                    name: 'shop-bundles',
                    component: () => import('@/Modules/Shop/views/shop/ShopBundles.vue'),
                    meta: { requiresPermission: abilities.VIEW_BUNDLE, requiresAccess: [moduleAbilities.SHOP_LITE, moduleAbilities.SHOP_MINI] }
                },
            ]
        },
        {
            path: 'warehouse',
            name: 'shop-warehouse',
            component: () => import('@/Modules/Shop/views/warehouse/Index.vue'),
            meta: { requiresPermission: [], requiresAccess: [moduleAbilities.STORE], requiresLicense: licenseModules.WAREHOUSES }
        },
        {
            path: 'warehouse/:id',
            name: 'shop-warehouse-view',
            component: () => import('@/Modules/Shop/views/warehouse/View.vue'),
            meta: { requiresPermission: [], requiresAccess: [moduleAbilities.STORE], requiresLicense: licenseModules.WAREHOUSES },
            children: [
                {
                    path: 'products',
                    name: 'shop-store-products',
                    component: () => import('@/Modules/Shop/views/warehouse/components/products/Index.vue'),
                    meta: { requiresPermission: [], requiresAccess: [moduleAbilities.STORE] }
                },
                {
                    path: 'users',
                    name: 'shop-store-users',
                    component: () => import('@/Modules/Shop/views/warehouse/components/users/Index.vue'),
                    meta: { requiresPermission: [], requiresAccess: [moduleAbilities.STORE] }
                },
                {
                    path: 'entries',
                    name: 'shop-store-entries',
                    component: () => import('@/Modules/Shop/views/warehouse/components/entries/Index.vue'),
                    meta: { requiresPermission: [], requiresAccess: [moduleAbilities.STOCK_LITE] }
                },
                {
                    path: 'supplies',
                    name: 'shop-store-supplies',
                    component: () => import('@/Modules/Shop/views/warehouse/components/supplies/Index.vue'),
                    meta: { requiresPermission: [], requiresAccess: [moduleAbilities.STOCK_LITE] }
                },
            ]
        },
        {
            path: 'sales/sessions',
            name: 'shop-sales-sessions',
            component: () => import('@/Modules/Shop/views/saleSessions/Index.vue'),
            meta: { requiresPermission: [], requiresAccess: [moduleAbilities.POS],requiresLicense: licenseModules.POS_WEB },
        },
        {
            path: 'sales/new-session',
            name: 'new-session',
            component: () => import('@/Modules/Shop/views/saleSessions/Sessions.vue'),
            meta: { requiresPermission: [], requiresAccess: [moduleAbilities.POS],requiresLicense: licenseModules.POS_WEB }
        },
        {
            path: 'sales/session/:id/details',
            name: 'sessions-details',
            component: () => import('@/Modules/Shop/views/saleSessions/sessionsDetails.vue'),
            meta: { requiresPermission: [], requiresAccess: [moduleAbilities.POS],requiresLicense: licenseModules.POS_WEB },

            children: [
                {
                    path: '',
                    name: 'sessions-sales',
                    component: () => import('@/Modules/Shop/views/saleSessions/sessionSales.vue'),
                    meta: { requiresPermission: [], requiresAccess: [moduleAbilities.POS],requiresLicense: licenseModules.POS_WEB }
                },
                {
                    path: 'products',
                    name: 'sessions-products',
                    component: () => import('@/Modules/Shop/views/saleSessions/sessionProducts.vue'),
                    meta: { requiresPermission: [], requiresAccess: [moduleAbilities.POS],requiresLicense: licenseModules.POS_WEB }
                },
            ]
        },
        {
            path: 'stock',
            name: 'stock-status',
            component: () => import('@/Modules/Shop/views/stock/Index.vue'),
            meta: { requiresPermission: [], requiresAccess: [moduleAbilities.STOCK_MINI, moduleAbilities.STOCK_LITE], requiresLicense: licenseModules.STOCK_STATUS_WEB}
        },

    ],

}
export const posRoute = {
    path: '/admin/shop',
    component: () => import('@/Modules/Shop/views/pos/layout/LayoutPos.vue'),
    meta: { requiresPermission: abilities.SHOP.VIEW, requiresAccess: [moduleAbilities.POS],requiresLicense: licenseModules.POS_WEB },
    children : [
        {
            path: 'pos',
            name: 'shop-pos',
            component: () => import('@/Modules/Shop/views/pos/PosInterface.vue'),
        }
    ]
}
